"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("@jsluna/utils");

var _AutocompleteField = _interopRequireDefault(require("./AutocompleteField"));

var _getOptionProperties = require("./getOptionProperties");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var MultiAutocompleteField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MultiAutocompleteField, _Component);

  function MultiAutocompleteField(props) {
    var _this;

    var defaultSelectedOptions = props.defaultSelectedOptions;
    _this = _Component.call(this, props) || this;
    _this.state = {
      inputValue: '',
      selectedOptions: defaultSelectedOptions
    };
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    _this.filterSelectedOptions = _this.filterSelectedOptions.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = MultiAutocompleteField.prototype;

  _proto.handleClear = function handleClear(selectedOption) {
    var selectedOptions = this.state.selectedOptions;
    var onSelect = this.props.onSelect;
    var newSelectedOptions = selectedOptions.filter(function (option) {
      return option !== selectedOption;
    });
    this.setState({
      inputValue: '',
      selectedOptions: newSelectedOptions
    });

    if (onSelect) {
      onSelect(newSelectedOptions);
    }
  };

  _proto.handleInputChange = function handleInputChange(e) {
    var onChange = this.props.onChange;
    this.setState({
      inputValue: e.target.value
    });

    if (onChange) {
      onChange(e);
    }
  };

  _proto.handleSelect = function handleSelect(selectedOption) {
    var selectedOptions = this.state.selectedOptions;
    var onSelect = this.props.onSelect;
    var newSelectedOptions = [].concat(selectedOptions, [selectedOption]);
    this.setState({
      inputValue: '',
      selectedOptions: newSelectedOptions
    });

    if (onSelect) {
      onSelect(newSelectedOptions);
    }
  };

  _proto.filterSelectedOptions = function filterSelectedOptions(option) {
    var selectedOptions = this.state.selectedOptions;
    var getOptionValue = this.props.getOptionValue;
    return !selectedOptions.find(function (selectedOption) {
      return getOptionValue(selectedOption) === getOptionValue(option);
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        selectedOptions = _this$state.selectedOptions,
        inputValue = _this$state.inputValue;
    var options = this.props.options;
    return /*#__PURE__*/_react.default.createElement(_AutocompleteField.default, _extends({}, (0, _utils.filterProps)(this.props, ['defaultSelectedOptions']), {
      options: options.filter(this.filterSelectedOptions),
      multiSelect: true,
      value: inputValue,
      selectedOptions: selectedOptions,
      onClear: this.handleClear,
      onSelect: this.handleSelect,
      onChange: this.handleInputChange
    }));
  };

  return MultiAutocompleteField;
}(_react.Component);

MultiAutocompleteField.propTypes = {
  onChange: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  defaultSelectedOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  getOptionValue: _propTypes.default.func
};
MultiAutocompleteField.defaultProps = {
  getOptionValue: _getOptionProperties.getOptionValue,
  onChange: undefined,
  onSelect: undefined,
  options: [],
  defaultSelectedOptions: []
};
MultiAutocompleteField.displayName = 'MultiAutocompleteField';
var _default = MultiAutocompleteField;
exports.default = _default;